import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Globals } from '../models/globals.model';
import { GlobalService } from '../services/global.service';
import { MLService } from '../services/ml-service';

@Component({
  selector: 'app-home-content',
  templateUrl: './home-content.component.html',
  styleUrls: ['./home-content.component.scss']
})
export class HomeContentComponent implements OnInit {
  modelMgmtUrl: string;
  flowsheetBuilderUrl: string;
  machineLearningUrl: string;
  monitoringUrl: string;
  gapAnalysisUrl: string;
  scenarioUrl: string;
  decisionUrl: string;
  instructionsUrl: string;
  apimUrl: string;
  foundationPlatformUrl: string;
  formulaBuilderUrl: string;
  dataCleansingUrl: string;
  configureModelUrl: string;
  hubUrl: string;
  constructor(public http: HttpClient, public globals: Globals, public globalService: GlobalService, public mlService: MLService) { }

  ngOnInit() {
    this.mlService.getToken().subscribe((response: any): void => {
      this.getUseCasesUrl();
    });
  }

  getUseCasesUrl() {
    this.mlService.getUseCasesUrl().subscribe((data: any): void => {
      this.modelMgmtUrl = data.ModelMgmt;
      this.globals.flowsheetBuilderUrl = data.FlowsheetBuilder;
      this.machineLearningUrl = data.MachineLearning;
      this.globals.monitoringUrl = data.Monitoring;
      this.globals.gapAnalysisUrl = data.GapAnalysis;
      this.globals.scenarioUrl = data.Scenario;
      this.decisionUrl = data.Decision;
      this.instructionsUrl = data.Instructions;
      this.apimUrl = data.ApimUrl;
      this.foundationPlatformUrl = data.FoundationPlatformUrl;
      this.formulaBuilderUrl = data.FormulaBuilderurl;
      this.dataCleansingUrl = data.DataCleansingUrl;
      this.configureModelUrl = data.ConfigureModelUrl;
      this.hubUrl = data.platformHubUrl;
    });
  }
}
